import { createJSONStorage } from 'zustand/middleware';
import { FretboardModel } from '@fretgenius/core/fretboard-model';

import { reportUiError } from '../../error/reporting';
import { FretboardConfigState } from '../types';
import { resolveValidTuningId } from './tuningUtils';

export function createFretboardPersistOptions(
  storage: ReturnType<typeof createJSONStorage>,
  reportErrorFn: (error: unknown, context?: Record<string, unknown>) => void
) {
  return {
    name: 'fretboard-preferences',
    storage,
    partialize: (state: FretboardConfigState) => ({
      instrumentType: state.instrumentType,
      tuningId: state.tuningId,
      numFrets: state.numFrets,
      heightRatio: state.heightRatio,
      useEqualTemperament: state.useEqualTemperament,
      useTrapezoidScaling: state.useTrapezoidScaling,
      noteCircleScale: state.noteCircleScale,
      isLeftHanded: state.isLeftHanded,
      accidentalPreference: state.accidentalPreference,
      fretWidthBase: state.fretWidthBase,
      showFretMarkerLabels: state.showFretMarkerLabels,
    }),
    onRehydrateStorage: () => {
      return (persistedState: FretboardConfigState | undefined, error?: unknown) => {
        if (error) {
          reportUiError(reportErrorFn, 'fretboard.onRehydrateStorage', error);
          return;
        }
        if (persistedState) {
          const safeTuningId = resolveValidTuningId(
            persistedState.instrumentType,
            persistedState.tuningId,
            'hydrate',
            reportErrorFn
          );
          if (safeTuningId !== persistedState.tuningId) {
            persistedState.tuningId = safeTuningId;
          }
          persistedState.fretboardModel = new FretboardModel({
            instrumentType: persistedState.instrumentType,
            tuningId: safeTuningId,
            numFrets: persistedState.numFrets,
          });
        }
      };
    },
  } as const;
}
